import {L} from "../../lt-ng/landcare-toolkit";
import {CustomLayers} from "../../services/custom-layer-service";
import {StyleEditor} from '@manaakiwhenua/ol-style-editor/src/index';
import TileLayer from "ol/layer/Tile";
import {LTServices} from "../../lt-ng/lt-services";
import VectorLayer from "ol/layer/Vector";
import Item = L.tree.Item;
import filterNodes = L.tree.filterNodes;
import CustomLayerService = CustomLayers.CustomLayerService;
import Layer = L.util.Layer;
import findNode = L.tree.findNode;
import IMapService = LTServices.IMapService;
import {hasLines, hasPoints, hasPolygons} from "../../utility/ol-vector";

interface ILayerSettingsScope extends ng.IScope {
	settingsItem: Item;
	layerTypes: { value: L.util.LayerType; name: string; }[];
	styleEditorCallbacks: { [key: string]: any };
	onLayerTypeChange();
	scales: number[];
	setMinScale();
	setMaxScale();
	styleEditorProps: any;
	StyleEditor: any;
	isStyleConfigurable(): boolean;
	// scaleStyle(s: number) : object;
}



export class LayerSettingsCtrl {
	public static $inject = [
		'$scope',
		'customLayerService',
		'landcareMapService'
	];

	constructor($scope: ILayerSettingsScope, customLayerService: CustomLayerService, protected mapService: IMapService) {
		$scope.StyleEditor = StyleEditor;

		// suppress inspection, as the 'unused' methods are used by the style editor component
		// noinspection JSUnusedGlobalSymbols
		$scope.styleEditorProps = {
			get styles() {
				return $scope.settingsItem && $scope.settingsItem.styleDefinition;
			},
			get baseLayer() {
				const node = findNode(mapService.treeData, (n: Item) => {
					return n.layerService && n.layerService.type === "BASE" && n.layer && n.layer.getVisible();
				});

				return new TileLayer({
					opacity: 1,
					source: Layer.olTileWMTSSourceFrom(node.layerService, true)
				});
			},
			get hasPolygons() {
				const node = $scope.settingsItem;
				const l = node && node.layer;
				return l instanceof VectorLayer ? hasPolygons(l) : false;
			},
			get hasPoints() {
				const node = $scope.settingsItem;
				const l = node && node.layer;
				return l instanceof VectorLayer ? hasPoints(l) : false;
			},
			get hasLines() {
				const node = $scope.settingsItem;
				const l = node && node.layer;
				return l instanceof VectorLayer ? hasLines(l) : false;
			}
		};
		$scope.styleEditorCallbacks = {
			changeStyle(ev) {
				console.log(ev);
				$scope.settingsItem.styleDefinition = ev.detail;
			}
		};

		$scope.isStyleConfigurable = () => {
			return $scope.settingsItem && $scope.settingsItem.styleDefinition
		}

		$scope.onLayerTypeChange = () => {
			filterNodes($scope.settingsItem, node => node.layer)
				.forEach(node => {
					node.layerType = $scope.settingsItem.layerType;
					let layer = node.layer;

					const spec = customLayerService.specForNode(node);

					layer.setZIndex(
						L.util.Layer.zIndexForLayerType($scope.settingsItem.layerType, spec && spec.order || 1)
					);
					layer.set('transparencyLayer', $scope.settingsItem.layerType == 'SCIENCE');
			});
		};

		$scope.scales = [
			0, 10000, 25000, 50000, 100000, 250000, 500000,
			1000000, 2000000, 4000000, 8000000
		];

		let lastValue = $scope.settingsItem;
		$scope.$watchGroup(['settingsItem.layerType', 'settingsItem.layerService.minScale', 'settingsItem.layerService.maxScale'], () => {
			if (lastValue && $scope.settingsItem == lastValue) {
				$scope.$emit('saveLayer', $scope.settingsItem);
			}
			lastValue = $scope.settingsItem;
		});

		$scope.setMinScale = () => {
			let layer = $scope.settingsItem.layer;
			let layerService = $scope.settingsItem.layerService;
			let minScale = layerService.minScale;

			let maxScale = layerService.maxScale;
			if (maxScale && minScale && maxScale <= minScale) {
				// unset the invalid max scale
				layerService.maxScale = 0;
			}

			L.util.Layer.setMinMaxResolutions(layer, layerService);
		};

		$scope.setMaxScale = () => {
			let layer = $scope.settingsItem.layer;
			let layerService = $scope.settingsItem.layerService;
			let maxScale = layerService.maxScale;
			let minScale = layerService.minScale;
			if (minScale && maxScale && minScale >= maxScale) {
				// unset the invalid min scale
				layerService.minScale = 0;
			}

			L.util.Layer.setMinMaxResolutions(layer, layerService);
		};

		// $scope.scaleStyle = (s: number) : object =>  {
		// 	let layerService = $scope.settingsItem.layerService;
		// 	let visible = (layerService.minScale ? s >= layerService.minScale : true) &&
		// 		(layerService.maxScale ? s <= layerService.maxScale : true);
		//
		// 	return {
		// 		height: '40px',
		// 		flex: 1,
		// 		background: visible ? 'blue' : 'transparent'
		// 	}
		// }
	}
}